import InvestmentsTable from './InvestmentsTable';

export default InvestmentsTable;
